import React from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components'

export default styled(({href, blank, children, ...others}) =>
  href
    ? <a target={blank ? '_blank' : ''} href={href} {...others}>{children}</a>
    : <Link {...others}>{children}</Link>
)`
  text-decoration: none;
  transition: color .15s ease-in;

  &:link,
  &:visited {
    transition: color .15s ease-in;
  }
  
  &:hover {
    transition: color .15s ease-in;
    text-decoration: underline;
  }
  
  &:active {
    transition: color .15s ease-in;
  }
  
  &:focus {
    transition: color .15s ease-in;
    outline: 1px dotted currentColor;
  }
`


// WEBPACK FOOTER //
// ./src/components/Link.js